









import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MyLoader extends Vue {
  @Prop()
  isInLoadingFlow!: boolean;

  @Prop()
  loadingText!: string;
}
